import bback from './images/cardback.png';

const CardBack = () => <img alt='Back of card' className='card' width='1000px' src={bback} />;

export default CardBack;